/* unplugin-vue-components disabled */import { render } from "./historyRecord.vue?vue&type=template&id=50005692&scoped=true&ts=true"
import script from "./historyRecord.vue?vue&type=script&lang=ts"
export * from "./historyRecord.vue?vue&type=script&lang=ts"

import "./historyRecord.vue?vue&type=style&index=0&id=50005692&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50005692"]])

export default __exports__